export default __webpack_public_path__ + "static/media/louPan.06dfdd13.png";